export default {
  REPORTED_USER_MGMT_REQUEST: 'APP/REPORTED_USER_MGMT/REPORTED_USER_MGMT_REQUEST',
  REPORTED_USER_MGMT_SUCCESS: 'APP/REPORTED_USER_MGMT/REPORTED_USER_MGMT_SUCCESS',
  REPORTED_USER_MGMT_ERROR: 'APP/REPORTED_USER_MGMT/REPORTED_USER_MGMT_ERROR',
};
